import axios from 'axios'
import store from '../store'
import * as Sentry from '@sentry/browser'
import {
  getRequestFile,
  getRequestFileBlobGateway,
  postRequestFile,
  deleteRequestFile
} from '@/services/api.service'

export async function getFileBlobv2(endpoint, signal) {
  try {
    const res = await getRequestFile(endpoint, signal)
    return res
  } catch (e) {
    if (e.message !== 'canceled') {
      Sentry.captureException(e)
      throw new Error({ msg: 'Could not load file', status: 'canceled' })
    }
  }
}

export async function postFilev2(endpoint, file, iD, typ) {
  try {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('objectId', iD) // need specific id it will send to
    formData.append('objectType', typ) // the type of the object ex: 'CONSTRUCTION'
    return await postRequestFile(endpoint, formData)
  } catch (e) {
    Sentry.captureException(e)
  }
}

export async function deleteFilev2(endpoint, file, iD, typ) {
  try {
    await deleteRequestFile(endpoint)
  } catch (e) {
    Sentry.captureException(e)
  }
}

export async function getFileBlob(endpoint) {
  const url = process.env.VUE_APP_API_FILE_SERVICE_URL + endpoint
  const headers = {
    'Access-Control-Allow-Origin': '*',
    Authorization: 'Bearer ' + store.state.oidcStore.access_token
  }
  try {
    const data = await axios.get(url, {
      headers: headers,
      responseType: 'blob'
    })
    return data
  } catch (e) {
    Sentry.captureException(e)
    console.error(e)
  }
}

export async function getAttachmentFileBlob(attachment) {
  try {
    const response = await getRequestFileBlobGateway(
      `${attachment.realmId}/${attachment.storageName}`
    )
    return response
  } catch (error) {
    Sentry.captureException(error)
    return undefined
  }
}
